var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "search_svg__path-1",
    d: "M17.094 15.086H16l-.41-.343c1.3-1.577 2.12-3.566 2.12-5.829C17.71 3.977 13.743 0 8.82 0 3.967 0 0 3.977 0 8.914c0 4.938 3.966 8.915 8.89 8.915 2.187 0 4.239-.823 5.811-2.126l.41.343v1.097L21.95 24 24 21.943zm-8.205 0a6.137 6.137 0 0 1-6.154-6.172A6.137 6.137 0 0 1 8.89 2.743a6.137 6.137 0 0 1 6.154 6.171 6.137 6.137 0 0 1-6.154 6.172"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "search_svg__Guidelines",
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "search_svg__icons-badges-variations",
    transform: "translate(-540 -311)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "search_svg__icons/search",
    transform: "translate(540 311)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "search_svg__mask-2",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#search_svg__path-1"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#search_svg__path-1",
    id: "search_svg__Shape",
    fill: "#4A4A4A",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "search_svg__color/black-tint/0-000000",
    fill: "#000",
    fillRule: "evenodd",
    mask: "url(#search_svg__mask-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "search_svg__gray-70-4A4A4A",
    d: "M0 0h24v24H0z"
  })))))));
};
export default SvgSearch;